import store from '@/store'
export default {
    computed: {
       posts() {return store.getters['app-ecommerce/getCurrentPosts']}
    }
}